export default function getNoDataProps(activeTab, searchQuery) {
    if (searchQuery) {
        return {
            title: "No Results Found",
            subtitle: `No match found for "${searchQuery}"`,
        };
    }

    if (activeTab === "today") {
        return {
            title: "No Visits Today",
            subtitle: "No customer activity recorded for today.",
        };
    }

    if (activeTab === "previous") {
        return {
            title: "No Past Records",
            subtitle: "No previous visits found for selected date.",
        };
    }

    if (activeTab === "upcoming") {
        return {
            title: "No Upcoming Visits",
            subtitle: "No scheduled customer visits found.",
        };
    }

    return {
        title: "No Records Found",
        subtitle: "No data available.",
    };
}